import { render, staticRenderFns } from "./NoticeAdd.vue?vue&type=template&id=16c10fc6&scoped=true"
import script from "./NoticeAdd.vue?vue&type=script&lang=js"
export * from "./NoticeAdd.vue?vue&type=script&lang=js"
import style0 from "./NoticeAdd.vue?vue&type=style&index=0&id=16c10fc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c10fc6",
  null
  
)

export default component.exports